//MODELS
PJQ.models = {};

PJQ.models.BaseModel = Backbone.Model.extend({
    idAttribute: "id",
    baseOptions: {},
    defaults: {},
    options: {},
    urlRoot: "/",
    subItems: {},
    hasEndpoint: function () {
        return this.endpoint() !== '/';
    },
    endpoint: function (action) {
        return '/';
    },
    isNew: function () {
        return this.id == null || this.id === 0 || Backbone.Model.prototype.isNew.call(this);
    },
    restore: function () {
        this.set(_.defaults(this.initAttributes, this.attributes));
        this.dirtyAttributes = {};
        this.isDirty = false;
    },
    hasChanged: function (attribute) {
        if (attribute != null) {
            return Backbone.Model.prototype.hasChanged.call(this, attribute);
        }

        return this.isDirty || _.size(this.dirtyAttributes) > 0 || _.find(this.subItems, function (itemClass, key) {
            let subItem = this[key];
            return subItem != null && typeof subItem.hasChanged === 'function' && subItem.hasChanged();
        }, this) != null;
    },
    hasNewAttachments() {
        return this.attachments != null && _.find(this.attachments.models, function (attachment) {
            return attachment.isNew()
        }) != null;
    },
    url: function (options, method) {
        return PJQ.helpers.urlHelpers.buildApiUrl(typeof this.endpoint === 'function' ? this.endpoint(options, method) : this.endpoint, {
            service: this.getService(options)
        });
    },
    getService: function (options) {
        let service;
        if (this.options.isAPIv2 || (options != null && options.isAPIv2)) {
            service = PJQ.constants.services.APIv2
        } else if (this.hasNewAttachments() || this.options.isFileAPI || (options != null && options.isFileAPI)) {
            service = PJQ.constants.services.FILES;
        } else if (this.options.isOrigin || (options != null && options.isOrigin)) {
            service = PJQ.constants.services.ORIGIN;
        } else if (_.size(this.options.service) > 0) {
            service = this.options.service;
        } else {
            return PJQ.constants.services.API;
        }
        return service;
    },
    beforeConstruct: function (attributes, options) {
    },
    constructor: function (attributes, options) {
        if (this.beforeConstruct(attributes, options) !== false) {
            attributes = this.parse(attributes, options);
            this.initAttributes = attributes;
            return Backbone.Model.prototype.constructor.call(this, attributes, options);
        }
    },
    beforeInit: function (options) {
    },
    initialize: function (model, options) {
        if (this.beforeInit(options) !== false) {
            this.fetchedAttributes = {};
            this.dirtyAttributes = {};
            this.isDirty = false;
            this.options = _.defaults(options ? options : {}, _.defaults(this.defaults ? this.defaults : {}, this.baseOptions));
            this.afterInit();
        }
    },
    afterInit: function () {
    },
    getChanged: function (attribute) {
        let result = this.dirtyAttributes[attribute];
        return result ? result : null;
    },
    reset: function (model) {
        this.clear();
        this.initAttributes = model;
        if (model) {
            this.set(this.parse(model));
        }
        this.isDirty = false;
        this.dirtyAttributes = {};
    },
    set: function (attribute, val, options) {
        let attrs = {};
        if (typeof attribute === 'string') {
            attrs[attribute] = val;
        } else {
            attrs = attribute;
            options = val;
        }
        if (options == null || (!options.silent && (!options.isPatch || options.attrs != null))) {
            this.isDirty = true;
            this.dirtyAttributes = _.extend(this.dirtyAttributes ? this.dirtyAttributes : {}, attrs);
        }
        return Backbone.Model.prototype.set.call(this, attrs, options);
    },
    sync: function (method, model, options) {
        let optsClone = _.clone(options);

        options.url = this.url(options.urlOptions, method);
        options.beforeSend = _.bind(function (xhr) {
            xhr.url = this.url(options.urlOptions, method);
            if (options.timeout) {
                xhr.timeout = options.timeout;
            }
            PJQ.helpers.apiHelpers.addHeaders(xhr, this.getService(options));
        }, this);

        // unless no error notification specified, always notify error
        let self = this,
            error = options.error,
            success = options.success;
        options.error = function (xhr) {
            let args = arguments,
                fnErr = function () {
                    if (options.notify !== false) {
                        new PJQ.ErrorHandler(options.errorHandlerOpts).handle(xhr, self.toJSON());
                    }
                    if (typeof error === 'function') {
                        return error.call(this, ...args);
                    }
                }
            if (xhr.status === 401 && options.canRetry !== false && self.getService(options) === PJQ.constants.services.APIv2) {
                PJQ.app.TokenManager.refreshAccessToken(_.bind(function (token) {
                    if (_.size(token) > 0) {// retry after refreshing the token
                        self.sync(method, model, _.defaults({
                            canRetry: false
                        }, optsClone));
                    } else {
                        fnErr();
                    }
                }, this));
            } else if (xhr.status === 401 && self.getService(options) === PJQ.constants.services.API && xhr.responseText === 'INVALID_SESSION') {
                PJQ.app.signOutNavigate();
            } else {
                fnErr();
            }
        };

        // only notify success if notify option is true
        if (options.notify === true && (method === 'update' || method === 'create') && _.size(self.notifyName) > 0) {
            options.success = function (request) {
                PJQ.notifications.notify.successNotify({
                    message: PJQ.helpers.stringHelpers.format('{0} {1} successfully', self.notifyName, method === 'update' ? 'saved' : 'created')
                });

                if (typeof success === 'function')
                    return success.call(this, ...arguments);
            };
        }

        return Backbone.Model.prototype.sync.call(this, method, model, options);
    },
    fetch: function (options) {
        let paramSuccess = options ? options.success : null,
            opts = _.defaults({
                success: _.bind(function (model, response) {
                    this.initAttributes = response;
                    this.dirtyAttributes = {};
                    this.isDirty = false;
                    this.isFetched = true;
                    this.trigger('fetch');
                    if (typeof paramSuccess === 'function')
                        paramSuccess(model, response);
                }, this)
            }, options ? options : {});
        return Backbone.Model.prototype.fetch.call(this, opts);
    },
    patch: function (attrs, options) {
        attrs = _.defaults(attrs ? attrs : {}, this.dirtyAttributes);
        this.dirtyAttributes = {};
        return this.save(attrs, _.defaults({type: 'PATCH', patch: true}, options));
    },
    put: function (attrs, options) {
        attrs = _.defaults(attrs ? attrs : {}, this.dirtyAttributes);
        this.dirtyAttributes = {};
        return this.save(attrs, _.defaults({type: 'PUT'}, options));
    },
    queuePatch: function (data, options = {}, timeout = 800) {
        this.queueSave(data, _.defaults(options ? options : {}, {isPatch: true}), timeout);
    },
    queueSave: function (data, options = {}, timeout = 800) {
        options = options ? options : {};
        //Set a timeout for saving
        //This can be used when save will be called a lot, and you don't want to send to the API constantly
        if (data) {
            this.set(data);

            if (options.isPatch) {
                this.queueData = _.defaults(this.queueData ? this.queueData : {}, data);
            }
        }

        clearTimeout(this.saveTimeout);
        this.saveTimeout = setTimeout(_.bind(function () {
            if (options.isPatch) {
                this.patch(this.queueData, options);
            } else {
                this.save(this.queueData, options);
            }
            this.queueData = null;
        }, this), timeout);
    },
    beforeSave: function () {
    },
    save: function (attributes, options) {
        this.beforeSave();
        let saveObject = this.getSaveObject(),
            saveOptions = this.getSaveOptions(),
            successCallback = options && options.success ? _.bind(options.success, this) : undefined;

        options = _.defaults({
            success: _.bind(function (model, response, opts) {
                this.dirtyAttributes = {};
                this.isDirty = false;
                this.afterSave(model, response, opts);
                if (successCallback) {
                    successCallback(model, response, opts);
                }
            }, this)
        }, options);

        if (saveObject) {
            if (attributes != null)
                _.defaults(attributes, saveObject);
            else
                attributes = saveObject;
        }
        if (saveOptions) {
            if (options != null)
                _.defaults(options, saveOptions);
            else
                options = saveOptions;
        }
        if (this.saveTimeout != null) {
            clearTimeout(this.saveTimeout);
        }
        return Backbone.Model.prototype.save.call(this, attributes, options);
    },
    afterSave: function () {

    },
    getSaveObject: function () {
        return null;
    },
    getSaveOptions: function () {
        return null;
    },
    formatString: function (str) {
        _.each(PJQ.helpers.stringHelpers.findMatches(/\[(.*?)]/gm, str), function (match) {
            if (match.group.toLowerCase().indexOf('fieldlabel') !== -1) {
                let fieldNumber = parseInt(match.group.toLowerCase().replace('fieldlabel', ''));
                if (fieldNumber > 0) {
                    let matchValue = this.getCustomFieldLabel(fieldNumber);
                    str = str.replace(match.full, matchValue != null ? matchValue : '');
                }
            } else if (match.group.toLowerCase().indexOf('fieldvalue') !== -1) {
                let fieldNumber = parseInt(match.group.toLowerCase().replace('fieldvalue', ''));
                if (fieldNumber > 0) {
                    let matchValue = this.getCustomFieldValue(fieldNumber);
                    str = str.replace(match.full, matchValue != null ? matchValue : '');
                }
            }
        }, this);
        return str;
    },
    getCustomFieldLabel: function (id) {
        if (this.customFields) {
            let match = this.customFields.get(id);
            if (match == null) {
                match = this.customFields.findWhere({fieldNumber: id});
            }
            return match ? match.get('fieldName') : null;
        }
        return _.find(this.get('customFields'), function (cf) {
            return (cf.id === id);
        });
    },
    getCustomFieldValue: function (id) {
        let customFields = this.get('customFields') ? this.get('customFields') : this.get('customFieldValues')
        let match = _.find(customFields, function (cf) {
            return (cf.id === id);
        });
        if (match == null) {
            match = _.find(customFields, function (cf) {
                return (cf.fieldNumber === id);
            });
        }
        return match ? match.value : null;
    },
    externalId: function () {
        let exObj = this.get('externalObject');
        return exObj != null && typeof exObj.externalId === 'string' ? exObj.externalId : null;
    },
    erpSyncStatus: function () {
        let exObj = this.get('externalObject');
        return exObj != null && typeof exObj.status === 'number' ? exObj.status : PJQ.constants.integrations.erp.syncStatuses.PENDING;
    },
    isERPSynced: function () {
        return _.size(this.externalId()) > 0;
    },
    makeERPUrl: function(integration){
        return null;
    }
});


//COLLECTIONS
PJQ.collections = {};

PJQ.collections.BaseCollection = Backbone.Collection.extend({
    baseOptions: {},
    defaults: {},
    options: {},
    urlRoot: "/",
    isFetched: false,
    url: function (options, method) {
        return PJQ.helpers.urlHelpers.buildApiUrl(typeof this.endpoint === 'function' ? this.endpoint(options, method) : this.endpoint, {
            service: this.getService(options)
        });
    },
    getService: function (options) {
        let service;
        if (this.options.isOrigin || (options != null && options.isOrigin)) {
            service = PJQ.constants.services.ORIGIN;
        } else if (this.options.isAPIv2 || (options != null && options.isAPIv2)) {
            service = PJQ.constants.services.APIv2
        } else if (this.options.isFileAPI || (options != null && options.isFileAPI)) {
            service = this.options.service;
        } else if (_.size(this.options.service) > 0) {
            service = this.options.service;
        } else {
            return PJQ.constants.services.API;
        }
        return service;
    },
    beforeConstruct: function (models, options) {
    },
    constructor: function (models, options) {
        if (this.beforeConstruct(models, options) !== false) {
            models = this.parse(models, options);
            return Backbone.Collection.prototype.constructor.call(this, models, options);
        }
    },
    beforeInit: function (options) {
    },
    initialize: function (models, options) {
        if (this.beforeInit(options) !== false) {
            this.options = _.defaults(options ? options : {}, _.defaults(this.defaults ? this.defaults : {}, this.baseOptions));
            if (models && models.length > 0)
                this.add(models, this.options);
            this.afterInit();
        }
    },
    afterInit: function () {
    },
    fetchFirst: function (options) {
        if (!this.isFetched)
            return this.fetch(options);
    },
    get: function (id) {
        if (PJQ.helpers.objectHelpers.refinedType(id) === 'array') {
            let result = [];
            _.each(id, _.bind(function (modelId) {
                let model = Backbone.Collection.prototype.get.call(this, modelId);
                if (model) {
                    result.push(model);
                }
            }, this));
            return result;
        }
        return Backbone.Collection.prototype.get.call(this, id);
    },
    fetch: function (options) {
        let paramSuccess = options ? options.success : null,
            opts = _.defaults({
                success: _.bind(function (models, response) {
                    this.isFetched = true;
                    this.trigger('fetch');
                    if (typeof paramSuccess === 'function')
                        paramSuccess(models, response);
                }, this)
            }, options ? options : {});
        return Backbone.Collection.prototype.fetch.call(this, opts);
    },
    fetchReset: function (options) {
        this.fetch(_.defaults(options ? options : {}, {reset: true}));
    },
    sync: function (method, model, options) {
        let optsClone = _.clone(options);

        options.url = this.url(options.urlOptions, method);
        options.beforeSend = _.bind(function (xhr) {
            xhr.url = this.url(options.urlOptions, method);
            if (options.timeout) {
                xhr.timeout = options.timeout;
            }
            PJQ.helpers.apiHelpers.addHeaders(xhr, this.getService(options));
        }, this);

        // unless no error notification specified, always notify error
        let self = this,
            error = options.error,
            success = options.success;
        options.error = function (xhr) {
            let args = arguments,
                fnErr = function () {
                    if (options.notify !== false) {
                        new PJQ.ErrorHandler(options.errorHandlerOpts).handle(xhr, self.toJSON());
                    }
                    if (typeof error === 'function') {
                        return error.call(this, ...args);
                    }
                }
            if (xhr.status === 401 && options.canRetry !== false && self.getService(options) === PJQ.constants.services.APIv2) {
                PJQ.app.TokenManager.refreshAccessToken(_.bind(function (token) {
                    if (_.size(token) > 0) {// retry after refreshing the token
                        self.sync(method, model, _.defaults({
                            canRetry: false
                        }, optsClone));
                    } else {
                        fnErr();
                    }
                }, this));
            } else if (xhr.status === 401 && self.getService(options) === PJQ.constants.services.API && xhr.responseText === 'INVALID_SESSION') {
                PJQ.app.signOutNavigate();
            } else {
                fnErr();
            }
        };

        // only notify success if notify option is true
        if (options.notify === true && (method === 'update' || method === 'create') && _.size(self.notifyName) > 0) {
            options.success = function (request) {
                PJQ.notifications.notify.successNotify({
                    message: PJQ.helpers.stringHelpers.format('{0} {1} successfully', self.notifyName, method === 'update' ? 'saved' : 'created')
                });

                if (typeof success === 'function')
                    return success.call(this, ...arguments);
            };
        }

        return Backbone.Collection.prototype.sync.call(this, method, model, options);
    },
    save: function (options) {
        return this.sync(options && options.put ? "update" : "create", this, options);
    },
    getChangedModels: function () {
        let changedModels = [];
        _.each(this.models, function (model) {
            if (model.hasChanged() || model.isNew())
                changedModels.push(model);
        });
        return changedModels;
    }
});


//VIEWS
PJQ.views = {};

PJQ.views.BaseView = Backbone.View.extend({
    opts: {
        isAppend: false,
        template: null,
        firstRenderAnimation: null,
        subTemplates: {},
        hasTooltips: false,
        shouldRenderTemplate: true
    },
    baseOptions: {},
    defaults: {},
    options: {},
    defaultEvents: {},
    events: {},
    beforeInit: function (options) {
    },
    initialize: function (options) {
        if (this.beforeInit(options) !== false) {
            let newOpts = _.defaults(this.baseOptions ? this.baseOptions : {}, this.opts);
            newOpts = _.defaults(this.defaults ? this.defaults : {}, newOpts);
            this.options = _.defaults(options ? options : {}, newOpts);
            if (this.defaultEvents != null) {
                this.undelegateEvents();
                this.events = _.defaults(this.events ? this.events : {}, this.defaultEvents);
                this.delegateEvents(this.events);
            }
            this.getTemplates(_.bind(function () {
                if (this.beforeFirstRender() !== false) {
                    this.render();
                }
            }, this));
        }
    },
    getTemplates: function (callback) {
        let templates = this.options.subTemplates ? this.options.subTemplates : {};
        templates.view_base = this.options.template;
        PJQ.templating.TemplateRenderer.fetchTemplates(templates, callback);
    },
    beforeFirstRender: function () {
    },
    renderData: function () {
        return this.options;
    },
    beforeRender: function () {

    },
    render: function (onlyIfRendered = false) {
        if (onlyIfRendered && !this.isFirstRenderDone) {
            return;
        }

        if (this.beforeRender() !== false) {
            if (this.options.template != null && (_.size(this.$el) > 0 && this.options.shouldRenderTemplate !== false)) {
                let data;
                if (typeof this.renderData === 'function') {
                    data = this.renderData();
                } else if (typeof this.renderData !== 'undefined') {
                    data = this.renderData;
                } else {
                    data = {};
                }
                PJQ.templating.TemplateRenderer.renderTemplate(this.options.isAppend, this.options.template, this.$el, data, _.bind(function () {
                    _.bind(this.rightAfterRender, this);
                    if (this.options.hasTooltips) {
                        let toolTips = this.$('[data-toggle="tooltip"]');
                        if (_.size(toolTips) > 0) {
                            toolTips.tooltip()
                        }
                    }
                    if (!this.isFirstRenderDone && this.options.firstRenderAnimation != null) {
                        this.$el.animateCSS(this.options.firstRenderAnimation, function () {
                            this.rightAfterRender();
                        }, this);
                    } else {
                        this.rightAfterRender();
                    }
                }, this));
            } else {
                this.rightAfterRender();
            }
            this.isFirstRenderDone = true;
        }
        return this;
    },
    rightAfterRender: function () {
        if (typeof this.options.afterRender === 'function')
            this.options.afterRender();

        this.afterRender()
    },
    afterRender: function () {

    },
    renderSubTemplate: function (isAppend, template, el, renderData, options) {
        let cb;
        if (typeof options === 'function') {
            cb = options;
        } else if (options && typeof options.callback === 'function') {
            cb = options.callback;
        }
        PJQ.templating.TemplateRenderer.renderTemplate(isAppend, template, el, renderData ? renderData : {}, cb, options);
    },
    addElements: function (element) {
        if (this.$addEl == null) {
            this.$addEl = [];
        }
        this.$addEl.push(element);
    },
    //YOU MUST CALLBACK WHEN OVERRIDING THIS FUNCTION IN AN EXTENDED CLASS
    beforeRemove: function (callback) {
        if (typeof callback === 'function')
            callback();
    },
    remove: function (callback) {
        this.beforeRemove(_.bind(function (result) {
            if (result !== false) {
                this.stopListening();
                this.undelegateEvents();
                this.$el.empty();
                if (_.size(this.$addEl) > 0) {
                    _.each(this.$addEl, function ($el) {
                        $el.empty();
                    });
                }

                if (typeof callback === 'function')
                    callback();
            }
        }, this));
    },
    stopPropagation: function (e) {
        if (e) {
            e.stopPropagation();
            e.cancelBubble = true;
        }
    }
});


//MODALS
PJQ.views.BaseModal = PJQ.views.BaseView.extend({
    baseOptions: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Default'),
        header: "",
        body: "",
        isVerticalCenter: false,
        isWrapForm: false,
        wrapFormName: null,
        isShowOkButton: true,
        okButtonText: "Ok",
        okButtonColorClass: 'primary',
        isShowCancelButton: false,
        cancelButtonText: "Cancel",
        cancelButtonColorClass: 'secondary',
        isShowSecondaryButton: false,
        secondaryButtonText: "",
        secondaryButtonColorClass: 'light',
        onSecondary: _.noop,
        onClose: _.noop,
        onOk: _.noop,
        width: null,
        minWidth: null,
        maxWidth: null,
        height: null,
        minHeight: null,
        maxHeight: null,
        fitHeight: false,
        isShowCloseButton: false,
    },
    defaults: {},
    options: {},
    defaultEvents: {
        'hidden.bs.modal': 'removeModal',
        'click .modal-ok': 'onOk',
        'click .modal-secondary': 'onSecondary',
        'click .modal-close': 'close'
    },
    events: {},
    beforeFirstRender: function () {
        this.options = _.defaults(this.options, {
            uuid: "modal-" + _.uniqueId()
        });
        //force element to null in case one was passed in
        //this view uses modals only so it creates its own container to insert into in the <body>
        this.setElement(null);
        if (this.beforeModalCreated() !== false) {
            this.createModal();
            this.afterModalCreated();
        }
    },
    beforeModalCreated: function () {
    },
    afterModalCreated: function () {
    },
    createModal: function () {
        this.container = $('#modalsContainer');
        if (_.size(this.container) === 0) {
            this.container = jQuery('<div id="modalsContainer" />');
            $('body').append(this.container);
        }
        this.modal = $('<div class="modal" role="dialog">');
        if (this.options.isVerticalCenter) {
            let verticalBox = $('<div class="modal-vertical-center">');
            this.modal.append(verticalBox);
            this.setElement(verticalBox);
        } else if (this.options.isWrapForm) {
            let form = $('<form name="' + this.options.wrapFormName + '"/>');
            this.modal.append(form);
            this.setElement(this.modal);
        } else {
            this.setElement(this.modal);
        }
        this.container.append(this.modal);
        this.modal.modal({
            backdrop: _.size($('.modal-backdrop.show')) === 0 ? 'static' : false,
            keyboard: false,
            show: true
        });

        this.$('.modal-dialog').attr('id', this.options.uuid);

        this.setZIndex();
    },
    getWidth: function () {
        return {
            minWidth: this.options.minWidth,
            maxWidth: this.options.maxWidth,
            width: this.options.width
        };
    },
    setWidth: function (widths) {
        this.modal.find('.modal-dialog').css({
            "min-width": widths.minWidth,
            "max-width": widths.maxWidth,
            "width": widths.width
        });
    },
    rightAfterRender: function () {
        if (this.modal != null) {
            this.setWidth(this.getWidth());

            // to use this there must be a modal body in the template
            // this will set the modal body to overflow auto which will make it scroll
            // if there is a different class you would like to scroll, it can be defined with modal-overflow
            // this functionality scales the body taking into account the footer/header heights
            // it also scales taking into account the height of elements in modal-body if modal-overflow is present
            if (this.options.fitHeight) {
                // get the top margin and multiply it by 2 so we get a uniform top/bottom margin
                let offset = parseInt(this.modal.find('.modal-dialog').css('margin-top').replace('px', '')) * 2,
                    $header = this.modal.find('.modal-header'),
                    $footer = this.modal.find('.modal-footer'),
                    $overflow = this.modal.find('.modal-overflow'),
                    $scrollContent = this.modal.find('.modal-body');

                if (_.size($overflow) > 0) {
                    // calculate the height of the siblings of the overflow element
                    offset += ($scrollContent.outerHeight() - $overflow.outerHeight());

                    // make the overflow element the content that will be set as scrollable with a max height
                    $scrollContent = $overflow;
                }

                // if there is a header, factor that into the offset for height calculation
                if (_.size($header) > 0) {
                    offset += $header.outerHeight();
                }

                // if there is a footer, factor that into the offset for height calculation
                if (_.size($footer) > 0) {
                    offset += $footer.outerHeight();
                }

                $scrollContent.css({
                    "min-height": (window.innerHeight - offset) + 'px',
                    "max-height": (window.innerHeight - offset) + 'px',
                    "overflow": "auto"
                });
            } else {
                this.modal.find('.modal-dialog').css({
                    "min-height": this.options.minHeight,
                    "max-height": this.options.maxHeight,
                    "height": this.options.height
                });
            }

            if (this.options.isShowCloseButton) {
                let button = $('<button>', {
                    class: 'btn btn-transparent-dark fs-22 btn-sm p-absolute modal-close',
                    style: 'top:-30px;right:-30px;'
                });
                button.append('<i class="fal fa-times"></i>');
                this.$('.modal-content').append(button);
            }

            PJQ.views.BaseView.prototype.rightAfterRender.call(this);
        }
    },
    setZIndex: function () {
        let isRemoved = (this.modal == null),
            ivIndex = parseInt($('.iv-image-view').css('z-index')),
            zIndex = 99999;
        if (!isNaN(ivIndex)) {
            zIndex = ivIndex;
        }
        $('#modalsContainer').find('.modal').each(function () {
            if ($(this).css('display') !== 'none' && $(this).css('zIndex').toString() !== 'auto' && parseInt($(this).css('zIndex').toString()) > zIndex)
                zIndex = parseInt($(this).css('zIndex').toString());
        });
        if (isRemoved) {
            $('.modal-backdrop').css("z-index", zIndex - 25);
        } else {
            $('.modal-backdrop').css("z-index", zIndex + 25);
            this.modal.css("z-index", zIndex + 50);
        }
    },
    removeModal: function () {
        if (this.modal != null) {
            this.modal.modal('hide');
            if (this.modal) {
                this.modal.remove();
                this.modal = null;
            }
            this.remove();
            if (_.size($('.modal:visible')) === 0) {
                $('.modal-backdrop').remove();
            } else {
                this.setZIndex();
                $(document.body).addClass('modal-open');
            }
            this.onRemove();
            this.undelegateEvents();
        }
    },
    close: function () {
        this.removeModal();
        this.onClose();
    },
    onRemove: function () {
        if (this.options.onRemove)
            arguments ? this.options.onRemove(...arguments) : this.options.onRemove(this.model);
    },
    onClose: function () {
        if (this.options.onClose)
            arguments ? this.options.onClose(...arguments) : this.options.onClose(this.model);
    },
    onSecondary: function () {
        if (this.options.onSecondary)
            arguments ? this.options.onSecondary(...arguments) : this.options.onSecondary(this.model);
    },
    onOk: function () {
        if (this.options.onOk)
            arguments ? this.options.onOk(...arguments) : this.options.onOk(this.model);
    }
});
